/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { LocationInformationFragment } from '../TruckSectionContent/types/LocationInformationFragment'
import { TruckInformationFragment } from '../../../HeroSection/types/TruckInformationFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type ShiftPageQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type ShiftPageQuery = {
  __typename: 'Query'
  location: {
    __typename: 'Location'
    id: number
    active: boolean | null
    customerUrl: string
    deadlineAt: any | null
    address: string
    allowOrders: boolean
    startTime: any
    endTime: any
    workStatus: Types.LocationWorkStatus
    workStatusHuman: string
    showAmountLeftToOrder: boolean
    amountLeftToOrderPercentage: number | null
    lot: {
      __typename: 'Lot'
      id: number
      lotUrl: string
      latitude: number
      longitude: number
      name: string
      address: string | null
      fullAddress: string
      appNotice: string | null
    }
    foodImage: { __typename: 'LocationFoodImage'; medium: string }
    truck: {
      __typename: 'Truck'
      id: number
      active: boolean
      instantBookEnabled: boolean
      showAsArchived: boolean
      preferredVendor: boolean
      name: string
      scheduleUrl: string
      menuUrl: string
      facebook: string | null
      instagram: string | null
      website: string | null
      twitter: string | null
      tiktok: string | null
      preferredVendorBadge: string | null
      restaurant: {
        __typename: 'Restaurant'
        id: number
        active: boolean | null
      }
      image: {
        __typename: 'TruckImage'
        medium: string
        original: string | null
      }
      description: { __typename: 'HtmlRecord'; html: string } | null
      foodImage: { __typename: 'TruckFoodImage'; medium: string } | null
      ratingInfo: {
        __typename: 'TruckRatingInfo'
        averageRating: number
        ratingsCount: number
        ratings: Array<{ __typename: 'PublicRating'; id: string }>
      } | null
      market: {
        __typename: 'Market'
        id: number
        customerPath: string
        name: string
        customerTrucksListPath: string
      }
      foodTypes: Array<{ __typename: 'FoodType'; id: number; name: string }>
    }
  }
  structuredData: {
    __typename: 'StructuredData'
    shiftPage: Array<string> | null
  }
}

export const ShiftPageQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShiftPageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lot' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lotUrl' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'latitude' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'longitude' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'foodImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } }
                    ]
                  }
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LocationInformationFragment' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'truck' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'active' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'restaurant' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TruckInformationFragment'
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'medium' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'original' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'instantBookEnabled' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'deadlineAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structuredData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shiftPage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' }
                      }
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    },
    ...LocationInformationFragment.definitions,
    ...TruckInformationFragment.definitions
  ]
} as unknown as DocumentNode

/**
 * __useShiftPageQuery__
 *
 * To run a query within a React component, call `useShiftPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useShiftPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShiftPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useShiftPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    ShiftPageQuery,
    ShiftPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<ShiftPageQuery, ShiftPageQueryVariables>(
    ShiftPageQueryDocument,
    options
  )
}
export function useShiftPageQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    ShiftPageQuery,
    ShiftPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<ShiftPageQuery, ShiftPageQueryVariables>(
    ShiftPageQueryDocument,
    options
  )
}
export type ShiftPageQueryHookResult = ReturnType<typeof useShiftPageQuery>
export type ShiftPageQueryLazyQueryHookResult = ReturnType<
  typeof useShiftPageQueryLazyQuery
>
export type ShiftPageQueryQueryResult = Apollo.QueryResult<
  ShiftPageQuery,
  ShiftPageQueryVariables
>
